import React, { useState, useEffect } from "react";
import Select from 'react-select';
import Accordion from 'react-bootstrap/Accordion'
import bin from './bin.png';


function Eje(props) {

    const [newProps, setNewProps] = useState(props);

    if (props !== newProps) {
        setNewProps(props);
    }

    let opcionesTipo = [
        { value: "dept", label: "Deprtamental" },
        { value: "mun", label: "Municipal" },
        { value: "PDET", label: "PDET" },
    ]

    let opcionesVariables = []
    props.direcciones.filter(address => address.l == "dept").forEach(item => {
        opcionesVariables.push(...item.fields.map(x => {
            return ({
                value: x.value,
                label: x.name,
                item: { ...x, range: [...x.range] },
                dim: item.n
            })
        }))
    })

    let optionsYear = []
    props.direcciones.find(address => address.l == "dept" && address.n == props.eje.dimension).years.map(year => {
        optionsYear.push({
            value: year,
            label: year
        })
    })

    function delButton() {
        if (props.del) {
            return (
                <div className="text-center pt-1 pb-2">
                    <button className="btn btn-default" onClick={eliminar}>
                        <img src={bin} className="rounded mx-auto d-block plus-icon" alt="..."></img>
                    </button >
                </div>
            )
        }
    }

    function ajustarAnio(newVal) {
        props.fun.cambiarAnioEje(newVal.value, props.eje.id)
    }

    function ajustarVariable(newVal) {
        props.fun.cambiarVariableEje(newVal.item, newVal.dim, props.eje.id)
    }

    function eliminar() {
        props.fun.eliminarEje(props.eje.id)
    }

    /*
        function ajustarTipo(newVal) {
        props.fun.cambiarTipoEje(newVal.value,props.eje.id)
    }

                            <div className="col-md-6 col-sm-12 col-xs-12">
                            <label className="form-label text-white">Tipo</label>
                            <Select
                                bsPrefix="form-control-sm"
                                options={opcionesTipo}
                                closeMenuOnSelect={true}
                                onChange={ajustarTipo}
                                defaultValue={opcionesTipo.find(item => item.value == props.eje.tipo)}
                            />
                        </div>
    */

    function obtenerAnio() {
        return { value: newProps.eje.year, label: newProps.eje.year }
    }

    function obtenerVar() {
        return { value: newProps.eje.vari.value, label: newProps.eje.vari.name }
    }

    return (

        <Accordion.Item eventKey={newProps.eje.id}>
            <Accordion.Header >
                <strong>{props.eje.id}.&nbsp;</strong>{newProps.eje.vari.name} {newProps.eje.year}
            </Accordion.Header>
            <Accordion.Body>
                <form className="row g-3 py-2">
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <label className="form-label">Variable</label>
                        <Select
                            bsPrefix="form-control-sm"
                            options={opcionesVariables}
                            closeMenuOnSelect={true}
                            onChange={ajustarVariable}
                            value={obtenerVar()}
                            defaultValue={obtenerVar()}
                            theme={props.darkMode ? (theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary: '#646a70',
                                  primary25: '#444a50',
                                  primary50: '#545a60',
                                  neutral0: '#343a40',
                                  neutral80: '#fff',
                                  neutral100: '#fff',
                                },
                              }): null}
                        />
                    </div>
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <label className="form-label">Año</label>
                        <Select
                            bsPrefix="form-control-sm"
                            options={optionsYear}
                            closeMenuOnSelect={true}
                            onChange={ajustarAnio}
                            defaultValue={obtenerAnio()}
                            value={obtenerAnio()}
                            theme={props.darkMode ? (theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary: '#646a70',
                                  primary25: '#444a50',
                                  primary50: '#545a60',
                                  neutral0: '#343a40',
                                  neutral80: '#fff',
                                  neutral100: '#fff',
                                },
                              }): null}
                        />
                    </div>
                </form>
                {delButton()}
            </Accordion.Body>
        </Accordion.Item>
    );

}

export default Eje;